import { AzureConfigurator } from "~/services/azure-configurator/azure-configurator";

export const isDebug = (): boolean => {
  try {
    return AzureConfigurator.getConfig()?.technical?.debug === "true";
  } catch (error) {
    return false;
  }
};
